export const DATE_CONSTRAINTS = ['dateOfApplication', 'plantingDate', 'terminationDate', 'tillageDate', 'harvestDate', 'dateApplied', 'year'];
